import React, { useEffect, useState, useRef } from 'react';
import dayjs from 'dayjs';

// apis
import { useUserSettings } from 'api/hooks';

// styles
import './MilestoneMarker.scss'

const MilestoneMarker = (props) => {
  const {
    milestones,
    milestone,
    offset,
    state,
    stateIndex,
    milestoneMarkerIndex,
    isFirst,
    isLast,
    milestoneIndex,
  } = props;
  const dateLabelRef = useRef()
  const [left, setLeft] = useState(null);
  const [height, setHeight] = useState(60)
  const initHeight = 60
  const { data: userSettings } = useUserSettings()

  let markerRef = useRef()

  let leftPosition = {
    markerTop: {
      left: -4
    },
    dateContainer: {
      left: -98
    },
    dateText: {
      textAlign: "right"
    }
  }

  useEffect(() => {
    let currHeight = initHeight + (30 * milestoneIndex);
    let isEven = milestoneIndex % 2 === 0 ? true : false

    if (isEven) setLeft(false)
    else setLeft(true)
    setHeight(currHeight)
  }, [milestones, milestone, state])

  let calcOffset = offset;
  
  if (isLast || isFirst) {
    calcOffset = 0
  }

  return (
    <div
      id={`milestone-marker-${stateIndex}-${milestoneMarkerIndex}`}
      className="milestone-marker"
      style={{
        height: height,
        left: `${calcOffset}%`,
        borderLeft: "1px solid #92959A"
      }}>
      <div className="milestone-marker-top-container">
        <div
          className="milestone-marker-top"
          style={left ? leftPosition.markerTop : {}}
        >
        </div>
      </div>
      <div
        className={`milestone-date milestone-date-${stateIndex}`}
        ref={markerRef}
        style={left ? leftPosition.dateContainer : {}}
        id={milestone.id}>
        <div
          className="date-label-title"
          style={left ? leftPosition.dateText : {}}>
          {milestone.type.replaceAll("_", " ").toUpperCase()}
        </div>
        <div
          className="date-label"
          ref={dateLabelRef}
          style={left ? leftPosition.dateText : {}}>
          {dayjs(milestone.value).format(userSettings?.date_format)}
        </div>
      </div>
    </div>
  );
};

export default MilestoneMarker;